import src from "IMAGE";
export default { src, width: 793, height: 635, blurWidth: 0, blurHeight: 0};
